import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { SubActivityApi, SubActivityGridDto, SubActivitySearch } from "../../../../../api";
import { CustomDataTable } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IPersonSubActivityJudgeSearchPanelProps {
  onSubActivitySelected: (subActivity: SubActivityGridDto) => void;
  personId: number;
}

export const PersonSubActivityJudgeSearchPanel: React.FunctionComponent<IPersonSubActivityJudgeSearchPanelProps> = ({
  personId,
  onSubActivitySelected,
}) => {
  const api = useApiService(SubActivityApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { activity: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: SubActivitySearch) =>
      api.baseSearch(
        SubActivitySearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: SubActivityGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                onSubActivitySelected(row);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Activity),
        fieldName: "activity",
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
    ],
    [onSubActivitySelected, t]
  );

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
